import { useState } from "react";
import { Button, Form, Modal, ListGroup } from "react-bootstrap";
import { createProduct } from "../api";

export default function CreateProduct({
    show,
    onHide,
    jwt,
    onCreated,
    categoryId,
    categories = [],
    places = []
}) {
    const [product, setProduct] = useState({
        name: '',
        coefficient: 1,
        categoryId: categoryId,
        placeIds: []
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        try {
            const createdProduct = await createProduct({
                name: product.name,
                coefficient: product.coefficient,
                categoryId: product.categoryId,
                placeIds: product.placeIds
            }, jwt);

            if (createdProduct) {
                const productWithPlaces = {
                    ...createdProduct,
                    places: product.placeIds.map(id => ({
                        productPlaceId: id,
                        name: places.find(p => p.id === id)?.name || ''
                    }))
                };
                onCreated(productWithPlaces);
            }
        } catch (error) {
            console.error('Error creating product:', error);
            alert('Не удалось создать товар');
        }
    };

    const resetForm = () => {
        setProduct({
            name: '',
            coefficient: 1,
            categoryId: categoryId,
            placeIds: []
        });
    };

    const togglePlaceSelection = (placeId) => {
        setProduct(prev => ({
            ...prev,
            placeIds: prev.placeIds.includes(placeId)
                ? prev.placeIds.filter(id => id !== placeId)
                : [...prev.placeIds, placeId]
        }));
    };

    return (
        <Modal centered show={show} onHide={onHide}>
            <Form onSubmit={e => { e.preventDefault(); onSubmit(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>Новый товар</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Название</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={product.name}
                            onChange={(e) => setProduct({ ...product, name: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Коэффициент</Form.Label>
                        <Form.Control
                            required
                            type="number"
                            min="0"
                            step="0.01"
                            value={product.coefficient}
                            onChange={(e) => setProduct({
                                ...product,
                                coefficient: parseFloat(e.target.value) || 0
                            })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Категория</Form.Label>
                        <Form.Select
                            value={product.categoryId || ''}
                            onChange={(e) => setProduct({
                                ...product,
                                categoryId: e.target.value ? parseInt(e.target.value) : null
                            })}
                        >
                            <option value="">Без категории</option>
                            {categories.map(c => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Маркетплейсы</Form.Label>
                        <ListGroup>
                            {places.map(place => (
                                <ListGroup.Item
                                    key={place.id}
                                    action
                                    active={product.placeIds.includes(place.id)}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        togglePlaceSelection(place.id)
                                    }}
                                >
                                    {place.name}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
                        Отмена
                    </Button>
                    <Button variant="success" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Создание...' : 'Создать'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}